import { render, staticRenderFns } from "./HostHeader.vue?vue&type=template&id=2d1be9e9&scoped=true&"
import script from "./HostHeader.vue?vue&type=script&lang=ts&"
export * from "./HostHeader.vue?vue&type=script&lang=ts&"
import style0 from "./HostHeader.vue?vue&type=style&index=0&id=2d1be9e9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1be9e9",
  null
  
)

export default component.exports